module.exports = __webpack_public_path__ + "static/img/erweima2.2121b4aa.png";